import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  isEmptyObject,
  getTenantData,
  isEmptyEvery,
  getDispositionTypeOnAPIFormat,
  isMobileDevice,
  getValueOrnull,
  getValueOrDefaultObject,
  getAndCheck,
  getTernaryValue,
  safeUpperCase,
  getEmptyObjectforNull,
  getValueOrEmptyString,
} from 'common/utilities/utils';
import { SecondaryHeader } from 'organisms/HeaderComponent';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import LockIcon from 'styles/staticAssets/images/Lock.svg';
import LocationOnIcon from 'styles/staticAssets/images/LocationOn.svg';
import WatchLaterIcon from 'styles/staticAssets/images/WatchLater.svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import Constants from './Constants/checkoutConstants';
import StartOrderContants from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import PriceSummary from './PriceSummary';
import Strips_Large_Cart from 'styles/staticAssets/images/Strips_Large_Cart.png';
import cart_header_mobile from 'styles/staticAssets/images/cart_header_mobile.png';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';

import Payment from './Payment';
import Ellipse from 'styles/staticAssets/images/Ellipse.svg';
import { Config } from '../../common/constants/SharedConstants';
import { ChannelManager } from 'common/manager';

import {
  styleForMaterialTextInput,
  errorStyleForMaterialTextInput,
  isMobileClassName,
  isMobilePadding,
  signInClick,
  getSchedule,
  typeInfo,
  typeOpts,
  getSubscribeData,
  getFullNameData,
  getPhoneData,
  getEmailData,
  getUserDetails,
  analyticsMethod,
  getUserInformation,
  getUserData,
  showCheckoutPageError,
  executeAnalyticsForInStore,
  kfcToCarCollectionPointCheck,
  resetOrderReducer,
  showCheckoutPageErrorAnalytic,
  embeddedErrorMessageAnalyticFn,
} from './CheckoutFn';

const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;
let isValueChecked = false;

const Checkout = props => {
  const {
    CHECKOUT_TITLES,
    DELIVERY,
    TAKEAWAY,
    IS_DELIVERY,
    IS_TAKEAWAY,
    IS_DINEIN,
    AGREEMENT_LABEL,
    CONTINUE_PAYMENT,
    FORM_NAMES,
    ADDRESS_PH,
    DINE_IN,
  } = Constants;
  const dispatch = useDispatch();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { SCHEDULE_ORDER_DATA } = StartOrderContants;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [finalAmount, setFinalAmount] = useState('');
  const [radioValue, setRadioValue] = useState('leaveatmydoor');
  const [isClickContinuePayment, setIsClickContinuePayment] = useState(false);
  const [paymentEnabled, setPaymentEnabled] = useState(false);
  const [isPaymentTypeSelected, setIsPaymentTypeSelected] = useState(
    getTernaryValue(userOrderState?.isPaymentAdded, userOrderState?.isPaymentAdded, false),
  );
  const [showPaymentError, setShowErrorPayment] = useState(false);
  const [showPaymentPreValidationError, setShowPaymentPreValidationError] = useState(false);
  const { cartReducer, tenantReducer, profileReducer, orderReducer } = useSelector(data => {
    return data;
  });
  const [userFullName, setUserFullName] = useState({
    value: getValueOrEmptyString(ChannelManager.name),
    errorMessage: '',
    error: false,
  });
  const [userPhone, setUserPhone] = useState({
    value: getValueOrEmptyString(ChannelManager.phone),
    errorMessage: '',
    error: false,
  });
  const [userEmail, setUserEmail] = useState({
    value: getValueOrEmptyString(ChannelManager.email),
    errorMessage: '',
    error: false,
  });
  const [userSubscription, setUserSubscription] = useState({
    value: true,
    errorMessage: '',
    error: false,
  });
  const [userInformation, setUserInformation] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [address2, setAddress2] = useState('');
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };
  const { flatResponse: { productMapById = {} } = {} } = getEmptyObjectforNull(
    useSelector(({ menuReducer }) => menuReducer),
  );
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionNew),
    JSON.parse(localStorage.getItem('dispositionNew')),
    userOrderState.dispositionNew,
  );
  const { type, store, date, time, deliveryAddress } = isEmptyObject(dispositionNew) ? dispositionNew : {};
  const { tenantId, currencySymbol, currencyConversionFactor, currencyShortName } = tenantReducer;
  const customerDetails = profileReducer?.basic;
  const { cartData = {}, isValidated = false } = cartReducer;
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const [createOrderRequest, setCreateOrderRequest] = useState({});

  useEffect(() => {
    if (props?.location?.ShowPaymentError) {
      setShowErrorPayment(true);
    }
  }, [props?.location?.ShowPaymentError]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(document.title, userFullName.error, userFullName.errorMessage);
  }, [userFullName.errorMessage, userFullName.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(document.title, userPhone.error, userPhone.errorMessage);
  }, [userPhone.errorMessage, userPhone.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(document.title, userEmail.error, userEmail.errorMessage);
  }, [userEmail.errorMessage, userEmail.error]);

  useEffect(() => {
    showCheckoutPageErrorAnalytic(orderReducer, showPaymentError, showPaymentPreValidationError);
  }, [orderReducer, showPaymentError, showPaymentPreValidationError]);

  useEffect(() => {
    localStorage.setItem('paymentStatus', '');
    localStorage.setItem('postPaymentType', '');

    isValueChecked = false;
    analyticsMethod(
      cartData,
      'BeginCheckoutClick',
      { currencyConversionFactor, userParams, currencyShortName },
      productMapById,
    );
    if (userParams.loggedIn) {
      analyticsMethod(cartData, 'AddContactInfoClick', { currencyConversionFactor }, productMapById);
    }
    resetOrderReducer(dispatch, orderReducer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const getCustomerDetails = () => {
    if (ChannelManager.isBrowser) {
      const customerData = getUserDetails(customerDetails);

      setUserFullName({
        ...userFullName,
        value: customerData.fullName,
      });
      setUserPhone({
        ...userPhone,
        value: customerData.phone,
      });
      setUserEmail({
        ...userEmail,
        value: customerData.email,
      });
    } else if (ChannelManager.isPhonePe) {
      setUserFullName({
        ...userFullName,
        value: ChannelManager.name,
      });
      setUserPhone({
        ...userPhone,
        value: ChannelManager.phone,
      });
      setUserEmail({
        ...userEmail,
        value: ChannelManager.email,
      });
    }
  };

  useEffect(() => {
    isEmptyObject(customerDetails) && userParams.loggedIn && getCustomerDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerDetails, userParams?.loggedIn]);

  // here we will validate the data and enable payment button based on required data
  useEffect(() => {
    const userFieldValue = Boolean(userFullName.value && userEmail.value && userPhone.value);
    const userFieldError = Boolean(userInformation.error || userFullName.error || userEmail.error || userPhone.error);

    setPaymentEnabled(getAndCheck(userFieldValue, !userFieldError));
    // triggering analytics method if user details exists
    if (getAndCheck(userFieldValue, !userFieldError)) {
      if (!isValueChecked && !userParams.loggedIn) {
        analyticsMethod(cartData, 'AddContactInfoClick', { currencyConversionFactor }, productMapById);
        isValueChecked = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInformation, radioValue, userFullName, userEmail, userPhone]);

  const updateUserDetails = event => {
    setIsClickContinuePayment(false);
    const inputValue = event.target.value;
    const inputName = event.target.name;
    const isChecked = event.target.checked;

    getUserData(inputName === ADDRESS_PH, () => setAddress2(inputValue));

    getUserData(inputName === FORM_NAMES.VEHICAL_INFORMATION, () =>
      setUserInformation({
        ...getUserInformation(userInformation, inputValue, type, radioValue),
      }),
    );

    getUserData(inputName === FORM_NAMES.DELIVERY_INSTRUCTION, () =>
      setUserInformation({
        ...getUserInformation(userInformation, inputValue, type),
      }),
    );

    getUserData(inputName === FORM_NAMES.SUBSCRIPTION, () =>
      setUserSubscription({
        ...getSubscribeData(userSubscription, isChecked),
      }),
    );

    getUserData(inputName === FORM_NAMES.FULL_NAME, () =>
      setUserFullName({
        ...getFullNameData(userFullName, inputValue),
      }),
    );

    getUserData(inputName === FORM_NAMES.PHONE, () =>
      setUserPhone({
        ...getPhoneData(userPhone, inputValue),
      }),
    );

    getUserData(inputName === FORM_NAMES.EMAIL, () =>
      setUserEmail({
        ...getEmailData(userEmail, inputValue),
      }),
    );
  };

  /**
   * Method to open open date time module
   */
  const scheduleOrderButtonClickHandler = (e, selectedStoreInfo) => {
    e.preventDefault();
    e.stopPropagation();
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: { showScheduleOrderCatering: true, selectedStoreInfo: selectedStoreInfo, changeFlow: true },
    });
  };

  useEffect(() => {
    let currencyChecks = Boolean(cartData?.total && currencySymbol && currencyConversionFactor);
    currencyChecks && setFinalAmount((cartData?.total / currencyConversionFactor).toFixed(2));
  }, [cartData, currencySymbol, currencyConversionFactor]);

  const handleRadioChange = () => {
    let radioChangeValue = getTernaryValue(radioValue === 'leaveatmydoor', 'handittome', 'leaveatmydoor');
    setRadioValue(radioChangeValue);
    setUserInformation({ ...userInformation, value: '', error: false });
    if (getAndCheck(safeUpperCase(type) === IS_TAKEAWAY, radioChangeValue === 'handittome')) {
      setUserInformation({ ...userInformation, value: '', error: true });
    }
  };

  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedTenantData = null,
    segmentedFooterData = null;

  const allReducerData = useSelector(data => {
    return {
      homePageContent: getValueOrnull(data?.contentReducer?.response),
      marketPageContent: getValueOrnull(data?.marketConfigReducer?.response),
      tenantReducerContent: getValueOrnull(data?.tenantReducer),
    };
  });

  if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    const {
      header = {}
    } = getValueOrDefaultObject(allReducerData?.marketPageContent?.headerData);
    segmentedMarketingData = getHeaderData(header);
  }

  const continuePaymentPlaceOrderClickHandler = () => {
    setShowPaymentPreValidationError(false);
    setShowErrorPayment(false);
    resetOrderReducer(dispatch, orderReducer);
    const request = {
      basketId: cartData?.id,
      tenders: [],
      customer: {
        id: cartData?.customer?.id,
        firstName: userFullName?.value || cartData?.customer?.firstName || '',
        lastName: userFullName?.value || cartData?.customer?.lastName || '',
        email: userEmail?.value || cartData?.customer?.email,
        phoneNumber: userPhone?.value || cartData?.customer?.phone,
        couponCodes: [],
        customProperties: null,
      },
    };

    if (userSubscription.value) {
      request.marketingPreferences = ['email', 'phone'];
    }

    if (safeUpperCase(type) === IS_DELIVERY) {
      request.isContactless = radioValue === 'leaveatmydoor';
      request.instruction = getTernaryValue(radioValue === 'leaveatmydoor', '', userInformation.value);
      request.addressLines = [address2];
      executeAnalyticsForInStore('DELIVERY', 'NA');
    }

    if (safeUpperCase(type) === IS_TAKEAWAY) {
      if (cartData?.availableCollectionPoints) {
        request.collectionPoint = {
          name: getTernaryValue(radioValue === 'leaveatmydoor', 'in-store', 'curbside'),
          bayNumber: 0,
        };
      }
      executeAnalyticsForInStore('PICKUP', radioValue);
      request.instruction = getTernaryValue(radioValue === 'leaveatmydoor', '', userInformation.value);
    }
    if (safeUpperCase(type) === IS_DINEIN) {
      request.collectionPoint = {
        name: 'in-store',
        bayNumber: 0,
      };
      executeAnalyticsForInStore('DINEIN', request.collectionPoint.name);
    }
    setCreateOrderRequest({
      tenantId,
      request,
    });
    getAndCheck(paymentEnabled, setIsClickContinuePayment(true));
    getAndCheck(ChannelManager.isBrowser, setPaymentEnabled(false));
  };

  useEffect(() => {
    if (getAndCheck(orderReducer, orderReducer?.error)) {
      getAndCheck(ChannelManager.isBrowser, setPaymentEnabled(true));
      setIsClickContinuePayment(false);
    }
  }, [orderReducer]);

  const validateUserDetails = () => {
    if (!paymentEnabled) {
      updateUserDetails({
        target: { value: userInformation.value, name: FORM_NAMES.VEHICAL_INFORMATION, checked: false },
      });
      updateUserDetails({ target: { value: userFullName.value, name: FORM_NAMES.FULL_NAME, checked: false } });
      updateUserDetails({ target: { value: userPhone.value, name: FORM_NAMES.PHONE, checked: false } });
      updateUserDetails({ target: { value: userEmail.value, name: FORM_NAMES.EMAIL, checked: false } });
    }
  };

  const paymentErrorHandler = paramObj => {
    if (paramObj && paramObj.errorCode === 'payTmMerchantIdError') {
      setIsClickContinuePayment(false);
      setPaymentEnabled(true);
      setShowPaymentPreValidationError(true);
    }
  };

  return (
    <React.Fragment>
      {isEmptyObject(segmentedMarketingData) && (
        <SecondaryHeader
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
          paymentHeader={false}
          checkoutHeader={true}
        />
      )}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
          contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
        }}
        userParams={userParams}
        showHeader={false}
      />
      <hr role='presentation' className='headerdivider' />
      <div className='checkoutPagecont'>
        <div className={`checkoutContainer${isMobileClassName(isMobile)}`} data-testid='checkout-page'>
          <img className='px-25px' alt='cart' src={getTernaryValue(isMobile, cart_header_mobile, Strips_Large_Cart)} />
          <div
            className={`checkoutHeader col-sm-7 col-md-12 col-lg-7 col-sm-12 mt-10px px-25px${isMobilePadding(
              isMobile,
            )}`}
          >
            <div className={`d-flex align-items-baseline justify-content-between`}>
              <h3 className={`checkoutTitle ${isMobileClassName(isMobile)}`}>
                {translateWithI18Next(CHECKOUT_TITLES.TITLE)}
              </h3>
              <div className='secure-checkout'>
                <img src={LockIcon} alt='' />
                <span>{translateWithI18Next('secureCheckout')}</span>
              </div>
            </div>
          </div>
          <div className={`checkoutBody${isMobileClassName(isMobile)} row`}>
            <div className='checkoutDescDetails col-sm-12 col-lg-7 col-md-12'>
              {/* Payment Error display  Or  Creation Order Backend Error display */}
              {orderReducer &&
                (orderReducer?.error || showPaymentError || showPaymentPreValidationError) &&
                showCheckoutPageError(orderReducer, showPaymentError, showPaymentPreValidationError)}

              {/* Info Session */}
              <div className={`row row-cols-12 mt-10px`}>
                <div className={`labelContent info-label pl-25px col-sm-4 col-12`}>
                  <h2>{translateWithI18Next(typeInfo(type))}</h2>
                </div>
                <div className={`deliveryInfoContent px-25px col-sm-8 col-12`}>
                  <div className='d-flex flex-column mt-20px'>
                    <div className='d-flex align-items-start mb-4'>
                      <label className='checkoutIcons'>
                        <img src={LocationOnIcon} alt='' />
                      </label>
                      <div className='d-flex w-100 justify-content-between align-items-start'>
                        <div className='addressBox'>
                          <span className='store_name d-block font-weight-bold'>{store?.name[0]?.value}</span>
                          {safeUpperCase(type) === IS_DELIVERY && <span>{deliveryAddress}</span>}
                          {[IS_TAKEAWAY, IS_DINEIN].includes(safeUpperCase(type)) && (
                            <span>{store.addresses[0]?.address?.addressLines[0]}</span>
                          )}
                          {safeUpperCase(type) === IS_DELIVERY && (
                            <div className='addressField'>
                              <input
                                id={ADDRESS_PH}
                                type='text'
                                name={ADDRESS_PH}
                                value={address2}
                                className='form-control'
                                placeholder={`${translateWithI18Next(ADDRESS_PH)}`}
                                onChange={updateUserDetails}
                              />
                              <label className='form-label'>{'Address 2'}</label>
                            </div>
                          )}
                        </div>
                        <button
                          type='button'
                          variant={'link dark'}
                          onClick={e => scheduleOrderButtonClickHandler(e, store)}
                          data-testid='schedule-order'
                        >
                          {translateWithI18Next('change')}
                        </button>
                      </div>
                    </div>
                    <div className='d-flex align-items-start mb-2'>
                      <label className='checkoutIcons'>
                        <img src={WatchLaterIcon} alt='' />
                      </label>
                      <div className='sceduledAt'>
                        {getSchedule({
                          time,
                          date,
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Options */}
              <div className={`row row-cols-12 mt-10px`}>
                <div
                  className={`labelContent-checkout-options pl-25px col-sm-4 col-12 ${getTernaryValue(
                    safeUpperCase(type) === IS_DINEIN,
                    'type-dine-in',
                    '',
                  )}`}
                >
                  <h2>{translateWithI18Next(typeOpts(type))}</h2>
                </div>
                <div className={`deliveryOptionsContent px-25px col-sm-8 col-12`}>
                  <div id='radioButtons' className='d-flex flex-column' value={radioValue} onChange={handleRadioChange}>
                    <div className='radioBtns'>
                      <input
                        type='radio'
                        id='leaveatmydoor'
                        name='checkoutoptions'
                        value='leaveatmydoor'
                        defaultChecked
                      />
                      <label for='leaveatmydoor'>
                        {
                          <>
                            <span className='leaveAtMyDoorTitle' tabIndex='0'>
                              {translateWithI18Next(
                                getTernaryValue(
                                  safeUpperCase(type) === IS_DELIVERY,
                                  DELIVERY.LEAVE_AT_MY_DOOR.TITLE,
                                  getTernaryValue(
                                    safeUpperCase(type) === IS_TAKEAWAY,
                                    TAKEAWAY.WALK_IN_THE_STORE.TITLE,
                                    DINE_IN.DINEIN_WALK_IN_THE_STORE.TITLE,
                                  ),
                                ),
                              )}
                            </span>
                            <div className='ml-25px option-note'>
                              {translateWithI18Next(
                                getTernaryValue(
                                  safeUpperCase(type) === IS_DELIVERY,
                                  DELIVERY.LEAVE_AT_MY_DOOR.DESC,
                                  TAKEAWAY.WALK_IN_THE_STORE.DESC,
                                ),
                              )}
                            </div>
                          </>
                        }
                      </label>
                    </div>
                    {dispositionOptionTitle(IS_TAKEAWAY, IS_DELIVERY, type, cartData, DELIVERY, TAKEAWAY)}
                  </div>
                  {dispositionOptionInstruction(
                    IS_TAKEAWAY,
                    IS_DELIVERY,
                    type,
                    cartData,
                    DELIVERY,
                    TAKEAWAY,
                    radioValue,
                    FORM_NAMES,
                    updateUserDetails,
                    userInformation,
                  )}
                </div>
              </div>

              {/* User Contact Info */}
              <div className={`row row-cols-12 mt-10px`}>
                <div className={`labelContent contact-label pl-25px  col-sm-4 col-12`}>
                  <h2>{translateWithI18Next(CHECKOUT_TITLES.CONTACT_INFO)}</h2>
                  {!userParams.loggedIn && (
                    <button
                      type='button'
                      className={`btn btn-outlined btn-margin btn-margin-in`}
                      data-testid='sign-in'
                      data-id={Config.CHECKOUT_SIGN_IN_ATTR_DATA_ID}
                      onClick={() => signInClick()}
                    >
                      Sign in
                    </button>
                  )}
                </div>

                <div className={`contactInfoContent  col-sm-8 col-12`}>
                  {!isMobile && <p className='mandatory-note'>{translateWithI18Next(Constants.mandatorynote)}</p>}
                  <MaterialTextInput
                    className={styleForMaterialTextInput(userFullName.error)}
                    placeholder={'Full Name*'}
                    onChange={updateUserDetails}
                    onBlur={updateUserDetails}
                    inputTestId='form-fullname'
                    name={FORM_NAMES.FULL_NAME}
                    value={userFullName.value}
                    autocomplete='off'
                    maxlength='26'
                  />
                  <div id='userFullName' className={errorStyleForMaterialTextInput(userFullName.error)}>
                    {userFullName.error && <img src={Ellipse} alt='error' className={`mr-2`} />}
                    <span role='alert'>{userFullName.errorMessage}</span>
                  </div>
                  <MaterialTextInput
                    className={styleForMaterialTextInput(userPhone.error)}
                    placeholder={'Phone Number*'}
                    onChange={updateUserDetails}
                    onBlur={updateUserDetails}
                    inputTestId='form-phone'
                    name={FORM_NAMES.PHONE}
                    value={userPhone.value}
                    autocomplete='off'
                    maxlength='10'
                  />
                  <div id='userFullName' className={errorStyleForMaterialTextInput(userPhone.error)}>
                    {userPhone.error && <img src={Ellipse} alt='error' className={`mr-2`} />}
                    <span role='alert'>{userPhone.errorMessage}</span>
                  </div>
                  <MaterialTextInput
                    className={styleForMaterialTextInput(userEmail.error)}
                    placeholder={'Email*'}
                    onChange={updateUserDetails}
                    onBlur={updateUserDetails}
                    inputTestId='form-email'
                    name={FORM_NAMES.EMAIL}
                    value={userEmail.value}
                    autocomplete='off'
                  />
                  <div id='userEmail' className={errorStyleForMaterialTextInput(userEmail.error)}>
                    {userEmail.error && <img src={Ellipse} alt='error' className={`mr-2`} />}
                    <span role='alert'>{userEmail.errorMessage}</span>
                  </div>
                  <div className='d-flex mt-20px mb-20px'>
                    <input
                      tabIndex='0'
                      id={FORM_NAMES.SUBSCRIPTION}
                      type='checkbox'
                      name={FORM_NAMES.SUBSCRIPTION}
                      className='common_checkbox mt-10px'
                      value={userSubscription.value}
                      onChange={updateUserDetails}
                      checked={userSubscription.value}
                    />
                    <label for={FORM_NAMES.SUBSCRIPTION} title className='form-check-label'>
                      {<span className='agreeTxt'>{translateWithI18Next(AGREEMENT_LABEL)}</span>}
                    </label>
                  </div>
                </div>
              </div>

              {/* Payment */}
              <Payment
                id='paymentComp'
                productMapById={productMapById}
                cartData={cartData}
                isValidated={isValidated}
                tenantId={tenantId}
                userEmail={userEmail?.value}
                userPhone={userPhone?.value}
                createOrderRequest={createOrderRequest}
                subscription={userSubscription?.value}
                checkoutProps={props}
                paymentEnabled={paymentEnabled}
                setIsPaymentTypeSelected={setIsPaymentTypeSelected}
                isClickContinuePayment={isClickContinuePayment}
                setIsClickContinuePayment={setIsClickContinuePayment}
                currencyConversionFactor={currencyConversionFactor}
                callBackValidateUserDetails={validateUserDetails}
                tenderInfo={userOrderState?.tenderInfo}
                paymentFormPayload={userOrderState?.paymentFormPayload}
                callBackPaymentErrorHandler={paymentErrorHandler}
              />
            </div>

            {/* Price summary session */}
            <div
              className={`checkoutAmountDetails mt-10px ${getTernaryValue(
                isMobile,
                'py-25px mobile',
                '',
              )} col-sm-12 col-lg-5 col-md-12`}
            >
              <div className='col-sm-12 col-12'>
                <div className={`p-3 ${getTernaryValue(isMobile, 'priceCard mobile', '')} card`}>
                  <PriceSummary
                    cartReducer={cartReducer}
                    tenantReducer={tenantReducer}
                    userParams={userParams}
                    type={type}
                    dispositionData={dispositionNew}
                  />
                  <button
                    id={CONTINUE_PAYMENT}
                    variant='outlined'
                    className={`${paymentEnabled && isPaymentTypeSelected ? 'enabled ' : ''}payButton`}
                    onClick={continuePaymentPlaceOrderClickHandler}
                    disabled={!getAndCheck(paymentEnabled, isPaymentTypeSelected)}
                  >
                    {/* to do with this button label */}
                    {`${translateWithI18Next(CONTINUE_PAYMENT)}`}
                    <span className='rupee-text'>
                      {' '}
                      {currencySymbol}
                      {finalAmount}{' '}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {userOrderState.showCartClearAlert && <ClearCartModule />}
    </React.Fragment>
  );
};

export const dispositionOptionTitle = (IS_TAKEAWAY, IS_DELIVERY, type, cartData, DELIVERY, TAKEAWAY) =>
  [IS_TAKEAWAY, IS_DELIVERY].includes(safeUpperCase(type)) &&
  kfcToCarCollectionPointCheck(cartData?.availableCollectionPoints, safeUpperCase(type)) && (
    <div className='radioBtns mt-10px pl-0px pr-0px'>
      <input type='radio' id='handittome' name='checkoutoptions' value='handittome' />
      <label for='handittome'>
        {
          <>
            <span className='handItToMe' tabIndex='0'>
              {translateWithI18Next(
                getTernaryValue(
                  safeUpperCase(type) === IS_DELIVERY,
                  DELIVERY.HAND_IT_TO_ME.TITLE,
                  TAKEAWAY.KFC_TO_YOUR_CAR.TITLE,
                ),
              )}
            </span>
            <div className='ml-25px option-note'>
              {translateWithI18Next(
                getTernaryValue(
                  safeUpperCase(type) === IS_DELIVERY,
                  DELIVERY.HAND_IT_TO_ME.DESC,
                  TAKEAWAY.KFC_TO_YOUR_CAR.DESC,
                ),
              )}
            </div>
          </>
        }
      </label>
      <hr className='handItToMe-hr' />
    </div>
  );

export const dispositionOptionInstruction = (
  IS_TAKEAWAY,
  IS_DELIVERY,
  type,
  cartData,
  DELIVERY,
  TAKEAWAY,
  radioValue,
  FORM_NAMES,
  updateUserDetails,
  userInformation,
) =>
  [IS_TAKEAWAY, IS_DELIVERY].includes(safeUpperCase(type)) &&
  kfcToCarCollectionPointCheck(cartData?.availableCollectionPoints, safeUpperCase(type)) && (
    <div className={`${radioValue}-radiobutton`}>
      <form className='deliveryInstrs mb-3'>
        <textarea
          id='instruction'
          className='textarea'
          name={`${getTernaryValue(
            safeUpperCase(type) === IS_DELIVERY,
            FORM_NAMES.DELIVERY_INSTRUCTION,
            FORM_NAMES.VEHICAL_INFORMATION,
          )}`}
          rows='2'
          placeholder={`${getTernaryValue(
            safeUpperCase(type) === IS_DELIVERY,
            translateWithI18Next(DELIVERY.HAND_IT_TO_ME.PLACE_HOLDER),
            translateWithI18Next(TAKEAWAY.KFC_TO_YOUR_CAR.PLACE_HOLDER),
          )}*`}
          aria-label={`${getTernaryValue(
            safeUpperCase(type) === IS_DELIVERY,
            translateWithI18Next(DELIVERY.HAND_IT_TO_ME.PLACE_HOLDER),
            translateWithI18Next(TAKEAWAY.KFC_TO_YOUR_CAR.PLACE_HOLDER),
          )}*`}
          maxlength='100'
          onChange={updateUserDetails}
          value={userInformation.value}
          onBlur={updateUserDetails}
        />
      </form>
      {getAndCheck(
        userInformation.error,
        <div id='deliveryInstrs' className='deliveryInstrs-error'>
          <span role='alert' className='deliveryInstrs-error'>
            {userInformation.errorMessage}
          </span>
        </div>,
      )}
    </div>
  );

export default Checkout;
